import { EDocumentPackageSignerRole } from "@rentiohq/shared-frontend/dist/reduxV2/documentPackage/documentPackage.types";
import {
  EDocumentPackageTypes,
  IDocumentPackage,
  IDocumentPackageSigner,
} from "@rentiohq/shared-frontend/dist/types/documentPackage.types";
import { EDocumentPackageStageSimple } from "@rentiohq/web-shared/dist/types";
import isEmpty from "ramda/es/isEmpty";
import isNil from "ramda/es/isNil";
import * as documentPackageUtils from "../../../utils/documentPackage.utils";

export const ORDER_MAP = ["createdAt", "", "", "", ""];

export const getSortQuery = (queryParams: any) => {
  if (!queryParams?.order) {
    return [{ field: "createdAt", method: "ASC" }];
  }

  const [field = "createdAt", method = "ASC"] = queryParams.order.split(" ");

  return [{ field, method }];
};

export const getFilterQuery = (values: any) => {
  let filters = [];

  if (values.stage && values.stage.length > 0) {
    let statuses: any = [];

    values.stage.forEach((simpleStage: EDocumentPackageStageSimple) => {
      statuses = [
        ...statuses,
        ...documentPackageUtils.getAdvancedStages(simpleStage),
      ];
    });

    filters.push({ status: { in: statuses } });
  }

  if (values.documentPackageType && values.documentPackageType.length > 0) {
    let types: any = [];
    values.documentPackageType.forEach((type: EDocumentPackageTypes) => {
      types = [...types, type];
    });

    filters.push({ type: { in: types } });
  }

  return { and: filters };
};

export const getHasActiveFilter = (filter: any) => {
  const hasQuery = !isEmpty(filter.query);
  const hasStage = !isEmpty(filter.stage) && !isNil(filter.stage);
  const hasContractType =
    !isEmpty(filter.documentPackageType) && !isNil(filter.documentPackageType);

  const hasFilter = [hasQuery, hasStage, hasContractType];

  return hasFilter.filter(Boolean).length > 0;
};

export const getUniqueSigners = (
  documentPackage: IDocumentPackage,
): IDocumentPackageSigner[] => {
  if (!documentPackage?.signers) {
    return [];
  }

  if (documentPackage.type === EDocumentPackageTypes.RentDeposit) {
    return documentPackage?.signers.filter(
      signer => signer.role !== EDocumentPackageSignerRole.Payer,
    );
  }

  return documentPackage?.signers;
};
